import React from 'react';
import { Space } from 'antd';

const NavigationBreadcrumb = ({
  items = [],
  style
}) => {
  return (
    <div style={{ 
      marginBottom: 16, 
      display: 'flex', 
      fontSize: 20,
      alignItems: 'center',
      paddingTop: '15px',
      ...style 
    }}>
      <Space split="/">
        {items.map((item, index) => (
          <span
            key={index}
            onClick={item.onClick}
            style={{
              color: item.onClick ? '#1890ff' : 'inherit',
              cursor: item.onClick ? 'pointer' : 'default',
              fontWeight: index === items.length - 1 ? 'bold' : 'normal',
              display: 'flex',
              alignItems: 'center'
            }}
          >
            {item.icon}
            {item.label}
          </span>
        ))}
      </Space>
    </div>
  );
};

export default NavigationBreadcrumb;
